import React, { Component } from 'react';
import ResponsiveTable from 'Components/ResponsiveTable';
import { Status } from 'Components/Status';
import Timer from 'Components/Timer';
import moment from 'moment';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { formatToINR } from 'Utils/transform';
import PostBidField from './postBidField';

class DisposalProductLineItems extends Component {
    constructor() {
        super();
        this.state = {
            tripDetails: [],
            selectedTrip: [],
            subTripDetails: []
        }
    }

    onSelectTrips = (e) => {
        let { selectedTrip } = this.state;
        const { trips } = this.props;
        if(e.target.checked) {
            selectedTrip = [];
            (trips || []).map(trip => {
                if(trip.is_loi_sent && !trip.is_accept) {
                    selectedTrip.push({
                        trip_id: trip.trip_id,
                        is_loi_with_cp_sent: trip.is_loi_with_cp_sent,
                        challenge_price: trip.challenge_price
                    });
                }
            });
        } else {
            selectedTrip = [];
        }
        this.setState({ selectedTrip })
    }

    acceptLoi = () => {
        const { selectedTrip } = this.state;
        this.props.postBidAll(2, selectedTrip);
        this.hideAcceptPopup();
    }

    rejectLoi = () => {
        const { selectedTrip } = this.state;
        this.props.postBidAll(3, selectedTrip);
        this.hideRejectPopup();
    }

    hideAcceptPopup = () => {
        this.setState({
            isLoiAcceptPopupShown: false,
            isLoiRejectPopupShown: false,
            selectedTrip: []
        })
    }

    hideRejectPopup = () => {
        this.setState({
            isLoiAcceptPopupShown: false,
            isLoiRejectPopupShown: false,
            selectedTrip: []
        })
    }

    showAcceptPopup = (trip) => {
        const selectedTrip = [{
            trip_id: trip['trip_id'],
            is_loi_with_cp_sent: trip.isLoiWithCPSent,
            challenge_price: trip.challengePrice
        }]
        this.setState({
            selectedTrip,
            isLoiAcceptPopupShown: true
        })
    }

    showRejectPopup = (trip) => {
        const selectedTrip = [{
            trip_id: trip['trip_id'],
            is_loi_with_cp_sent: trip.isLoiWithCPSent,
            challenge_price: trip.challengePrice
        }]
        this.setState({
            selectedTrip,
            isLoiRejectPopupShown: true
        })
    }

    onAcceptRejectLoi = (type) => {
        if(this.state.selectedTrip.length > 0) {
            this.props.postBidAll(type, this.state.selectedTrip);
        }
    }

    acceptClicked = (trip) => {
        const { selectedTrip } = this.state;
        const tripExistIndex = (selectedTrip || []).findIndex(strip => strip.trip_id === trip.trip_id);
        if(tripExistIndex === -1) {
            selectedTrip.push({
                trip_id: trip['trip_id'],
                is_loi_with_cp_sent: trip.isLoiWithCPSent,
                challenge_price: trip.challengePrice
            });
        }  else {
            selectedTrip.splice(tripExistIndex, 1);
        }
        this.setState({ selectedTrip });
    }

    render() {
        const { trips, biddingStage, systemTime, bidSubmitList, rfq } = this.props;
        const { tripDetails, selectedTrip, subTripDetails } = this.state;
        const isDepotWise = (((rfq || {}).rfqDetails || {}).disposalContractType !== 2);
        return (
            <div className="box-shadow col-1 pv-10 ph-5 mt-20">
                 <ResponsiveTable className="courier-table pt-10 ph-10 pb-80">
                    <table cellpadding="0" cellspacing="0" className="col-1">
                        <thead>
                           <tr>
                               <th>Sl No.</th>
                               <th>Zone</th>
                               {isDepotWise && <>
                               <th>Depot Code</th>
                               <th>Depot Name</th>
                               </>}
                               <th>Total Price</th>
                               <th>Lifting Date</th>
                               <th>Bid Price</th>
                               <th>
                                {'Status'}
                                    <div>
                                    {biddingStage['complete'] && <input type="checkbox" name="acceptorrejectcp" checked={selectedTrip.length > 0 && selectedTrip.length === (trips || []).filter(trip => trip.is_loi_sent && !trip.is_accept).length}  onClick={(e) => { e.stopPropagation(); this.onSelectTrips(e) }} />}
                                        {biddingStage['complete'] && <><span className="fBold fs-16 pt-5 curP pr pl-15" onClick={(e) => { e.stopPropagation(); this.onAcceptRejectLoi(2) }}>{'Accept'}</span> / <span className="fBold fs-16 pt-5 curP pr" onClick={(e) => { e.stopPropagation(); this.onAcceptRejectLoi(3)}}>{'Reject'}</span></>}
                                    </div>
                                </th>
                               {/* <th>Actions</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {(trips || []).map((trip, valIndex) => {
                            return(<>
                                <tr style={{'backgroundColor': '#d4f2ff'}}>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{valIndex + 1} <span className='theme-color curP fBold' onClick={() => {
                                        const { tripDetails } = this.state;
                                        if(tripDetails.includes(trip.trip_id)) {
                                            tripDetails.splice(tripDetails.indexOf(trip.trip_id), 1);
                                        } else {
                                            tripDetails.push(trip.trip_id)
                                        }
                                        this.setState({ tripDetails })
                                    }}>{!tripDetails.includes(trip.trip_id) ? '+' : '-'}</span></td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.zone}</td>
                                    {isDepotWise && <>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.from}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.depo_name}</td>
                                    </>}
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR(trip.total_price || trip.totalPrice)}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.contract_tenure_from && moment(trip.contract_tenure_from).format('DD/MM/YYYY') || ''} - {trip.contract_tenure_from && moment(trip.contract_tenure_to).format('DD/MM/YYYY') || ''}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>{trip.price && formatToINR(trip.price)}</td>
                                    <td style={{ 'borderBottom': '1px solid grey'}}>
                                        <Status 
                                            status={trip.status && {
                                                statusText: trip.status.status_text,
                                                colorCode: trip.status.color_code
                                            } || {}}
                                            hideText={true}
                                        />
                                            {trip.is_loi_sent && !trip.is_accept && trip.loi_accept_valid_to < systemTime && <div className="error-color fs-14 fBold mb-5">LOI Ignored</div>}
                                            {trip.is_loi_sent && trip.is_accept === true && <div className="challenge-color fs-14 fBold mb-5">LOI Accepted</div>}
                                            {!trip.is_loi_sent && trip.is_accept === false && <div className="error-color fs-14 fBold mb-5">LOI Rejected</div>}

                                            {trip.is_loi_sent && !trip.is_accept && trip.loi_accept_valid_from && trip.loi_accept_valid_to &&
                                                trip.loi_accept_valid_to >= systemTime &&
                                                <>
                                                    <div className="flex flex-between flex-middle wt-165">
                                                        <input type="checkbox" name="acceptorrejectlois" className="" checked={selectedTrip && selectedTrip.find((loi) => loi['trip_id'] === trip['trip_id'])} onClick={(e) => { e.stopPropagation(); this.acceptClicked(e, trip) }} />
                                                        <span className="fSemibold pr-5 fs-14">LOI : </span>
                                                        <span className="challenge-color curP pr-5 curP fBold fs-14" 
                                                        onClick={(e) => { e.stopPropagation(); this.showAcceptPopup(trip) }}>
                                                            Accept
                                                            </span>
                                                        <span className="pr-5 curP"> / </span>
                                                        <span className="pr-5 error-color curP fBold fs-14" onClick={(e) => { e.stopPropagation(); this.showRejectPopup(trip) }}>Reject</span><br />
                                                    </div>
                                                    {
                                                    trip.loi_accept_valid_from && trip.loi_accept_valid_to &&
                                                    trip.loi_accept_valid_to >= systemTime &&
                                                        <div className="zone-loi-timer">
                                                        <Timer from={trip.loi_accept_valid_from} to={trip.loi_accept_valid_to} currentTime={systemTime} />
                                                        </div>
                                                    
                                                    }
                                                {/* </div> */}
                                                </>
                                                }
                                    </td>
                                </tr>
                                {tripDetails.includes(trip.trip_id) && 
                                <tr>
                                    <td colSpan={isDepotWise ? '8' : '6'}>
                                    <table cellpadding="0" cellspacing="0" className="col-1 mb-20">
                                        <thead>
                                        <tr>
                                            {isDepotWise && <>
                                            <th style={{'backgroundColor': '#486aa3'}}>Zone</th>
                                            <th style={{'backgroundColor': '#486aa3'}}width="200">Depot Name</th>
                                            </>}
                                            <th style={{'backgroundColor': '#486aa3'}} width="250">Material Desc.</th>
                                            {isDepotWise && <th style={{'backgroundColor': '#486aa3'}} width="80">Product Type</th>}
                                            <th style={{'backgroundColor': '#486aa3'}} width="50">MSP</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="25">Quantity</th>
                                            {isDepotWise && <th style={{'backgroundColor': '#486aa3'}} width="25">UOM</th>}
                                            <th style={{'backgroundColor': '#486aa3'}} width="50">Price</th>
                                            <th style={{'backgroundColor': '#486aa3'}} width="50">Total Bid Price</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {(trip.sub_trip_disposal_product || []).map((subTrip, subTripIndex) => (
                                            
                                            <>
                                            <tr>
                                                {isDepotWise && <>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.zone}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.depo_name}</td>
                                                </>}
                                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                                    {subTrip.material_code_description}
                                                    <span className='theme-color curP fBold fs-20 ml-10' onClick={() => {
                                                        const { subTripDetails } = this.state;
                                                        if(subTripDetails.includes((trip.trip_id + subTripIndex))) {
                                                            subTripDetails.splice(subTripDetails.indexOf((trip.trip_id + subTripIndex)), 1);
                                                        } else {
                                                            subTripDetails.push((trip.trip_id + subTripIndex))
                                                        }
                                                        this.setState({ subTripDetails })
                                                    }}>{!subTripDetails.includes(trip.trip_id + subTripIndex) ? '+' : '-'}</span>
                                                </td>
                                                {isDepotWise && <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.product_type}</td>}
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{formatToINR((subTrip.bidding_and_payments || {}).qbr)}</td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.quantity}</td>
                                                {isDepotWise && <td style={{ 'borderBottom': '1px solid grey'}}>{subTrip.pricing_basis_name}</td>}
                                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                                    {biddingStage['complete'] ? 
                                                    <>{subTrip.price && formatToINR(subTrip.price)}</>
                                                    :
                                                    <>
                                                    <PostBidField
                                                        isDepotWise={isDepotWise}
                                                        rfq={rfq}
                                                        lineItem={subTrip} 
                                                        postDisposalBid={this.props.postDisposalBid}
                                                        bidSubmitList={bidSubmitList}
                                                        trip={trip}
                                                        price={subTrip.price}
                                                        postBidAll={this.props.postBidAll}
                                                        readyToPostBid={this.props.readyToPostBid}
                                                        colorCode = {( subTrip.bid_error_status && subTrip.bid_error_time && subTrip.bid_error_status===true && (subTrip.bid_error_time > new Date().getTime())) ? 
                                                            subTrip.bid_error_color_code : 'white'}
                                                    />
                                                    <div>
                                                        { subTrip.bid_error_status && subTrip.bid_error_time && subTrip.bid_error_status===true && 
                                                        (subTrip.bid_error_time > new Date().getTime()) ?
                                                        subTrip.bid_error_message && <b style={{color:'green'}}>{subTrip.bid_error_message}</b>:""}
                                                    </div>
                                                    </>
                                                    }
                                                </td>
                                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                                    {/* <Status 
                                                        status={trip.status && {
                                                            statusText: trip.status.status_text,
                                                            colorCode: trip.status.color_code
                                                        } || {}}
                                                        hideText={true}
                                                    /> */}
                                                    <div className='fBold theme-color ml-10'>{formatToINR(subTrip.bid_quantity_cost)}</div>
                                                </td>
                                            </tr>
                                            {(subTrip.disposal_material_trip || []).length > 0 && subTripDetails.includes(trip.trip_id + subTripIndex) && <tr>
                                                <td colSpan={(isDepotWise ? '9' : '7')} style={{'padding': '0px 20px 15px 20px'}}>
                                                    <table cellpadding="0" cellspacing="0" className="col-1 mb-5">
                                                        <thead>
                                                            <tr>
                                                                <th>Depot Code</th>
                                                                <th>Depot Name</th>
                                                                <th>MSP</th>
                                                                <th>Quantity</th>
                                                                <th>UOM</th>
                                                                <th>Price</th>
                                                                <th>Total Bid Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(subTrip.disposal_material_trip || []).map((strip, sIndex) => (
                                                            <tr>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.depo_code}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.depo_name}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{formatToINR((strip.bidding_and_payments || {}).qbr)}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.quantity}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.pricing_basis_name}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{strip.price}</td>
                                                                <td style={{ 'borderBottom': '1px solid grey', 'background': '#f0ffff'}}>{formatToINR(strip.bid_quantity_cost)}</td>
                                                            </tr>))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>}
                                            </>
                                            ))}
                                        </tbody>
                                    </table>
                                    </td>
                                </tr>
                                }
                            </>)})}
                        </tbody>
                    </table>
                </ResponsiveTable>
                {this.state.isLoiAcceptPopupShown && <ConfirmationPopup text={'Are You Sure You Want To Accept LOI?'} onConfirm={this.acceptLoi} onCancel={this.hideAcceptPopup} />}
			    {this.state.isLoiRejectPopupShown && <ConfirmationPopup text={'Are You Sure You Want To Reject LOI?'} onConfirm={this.rejectLoi} onCancel={this.hideRejectPopup} />}
            </div>
        )
    }
}

export default DisposalProductLineItems;